class Config {
  constructor () {
    this.env = undefined
    this.config = {}
    this.environments = []
  }

  default (config = {}) {
    this.config = Object.assign({}, config)

    return this
  }

  environment (match, config = {}) {
    this.environments.push({
      match: match,
      config: config,
    })

    return this
  }

  detect () {
    let location = window.location.href
    let config = {}

    this.environments.forEach((environment) => {
      if (environment.match.test(location)) {
        config = Object.assign({}, config, environment.config)
      }
    })

    this.config = Object.assign({}, this.config, config)

    return this
  }

  get (name = '') {
    // convert indexes to properties
    name = name.replace(/\[(\w+)\]/g, '.$1')
    // strip a leading dot
    name = name.replace(/^\./, '')

    let a = name.split('.')
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i]
      if (k in this.config) {
        return this.config[k]
      } else {
        return false
      }
    }
    return false
  }

  set (obj = {}) {
    this.config = Object.assign({}, this.config, obj)
    return this
  }
}

export default new Config()
